var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ProgressBar, Button, Modal, ModalHeader, ModalBody, useBreakpoint, } from '@one-thd/sui-atomic-components';
import { BenefitCardMW, BenefitCardFullWidthDTW, BenefitCardHalfWidthDTW, CardButtonRH, } from '../../../shared/rewards-hub';
import { getImageURL } from '../../../../utils/GeneralUtil';
import { RewardsHistoryDTW, RewardsHistoryMW } from './PaintRewardsHistory';
import { RewardsHubContext } from '../../../../contexts';
import { floorNumberWithCommas } from '../../../Utils';
import { PaintInfoTooltip } from './PaintComponents';
import { analyticsStash, analyticsOverlay } from '../../../../utils/analytics';
import { rhAnalytics } from '../../../../constants/RewardsHub';
import { newrelic, REWARDS_HUB_PAINT_VIEW_HISTORY_CLICK, } from '../../../../utils/newrelic';
var constants = {
    title: "Paint Rewards",
    headline: {
        Member: "Save on Paints, Stains, and Primers",
        Bronze: "You\u2019re Earning 10% Off on Paint Products",
        Silver: "",
        Gold: "You\u2019re Earning 20% Off on Paint Products",
    },
    iconUrl: {
        Member: getImageURL("WelcomeCard/paint_Member.svg"),
        Bronze: getImageURL("WelcomeCard/paint_Bronze.svg"),
        Silver: getImageURL("WelcomeCard/paint_Silver.svg"),
        Gold: getImageURL("WelcomeCard/paint_Gold.svg"),
    },
    headerButton: (React.createElement(CardButtonRH, { url: "/", label: "View History", variant: "text", callback: function () {
            analyticsStash(rhAnalytics.viewPaintHistoryStash);
        } })),
    subtitle: "Save 10% on 1 gallon or larger paints, stains, primers and solvents when you spend $1,000 and unlock Bronze Paint Rewards. Automatically get Bronze savings when you reach Pro Xtra Elite status.",
};
var getPaintSubtitle = function (paintLevel, nextLevelName) {
    var percentage = '';
    var nextAmount = '0';
    var status = '';
    var message = '';
    if (paintLevel === 'Member') {
        percentage = '10%';
        nextAmount = '$1,000';
        status = 'Pro Xtra Elite';
        message = "Save ".concat(percentage, " on 1 gallon or larger paints, stains, primers and solvents when you spend ").concat(nextAmount, " and unlock ").concat(nextLevelName, " Paint Rewards. Automatically get ").concat(nextLevelName, " savings when you reach ").concat(status, " status.");
    }
    else if (paintLevel === 'Bronze') {
        percentage = '15%';
        nextAmount = '$3,500';
        message = "Save ".concat(percentage, " on 1 gallon or larger paints, stains, primers and solvents when you spend ").concat(nextAmount, " and unlock ").concat(nextLevelName, " Paint Rewards.");
    }
    else if (paintLevel === 'Silver') {
        percentage = '20%';
        nextAmount = '$6,500';
        status = 'Pro Xtra VIP';
        message = "Save ".concat(percentage, " on 1 gallon or larger paints, stains, primers and solvents when you spend ").concat(nextAmount, " and unlock ").concat(nextLevelName, " Paint Rewards. Automatically get ").concat(nextLevelName, " savings when you reach ").concat(status, " status.");
    }
    else if (paintLevel === 'Gold') {
        message = "";
    }
    return message;
};
var getPaintIcon = function (currentLevel) {
    if (currentLevel === 'Member') {
        return constants.iconUrl.Member;
    }
    if (currentLevel === 'Bronze') {
        return constants.iconUrl.Bronze;
    }
    if (currentLevel === 'Silver') {
        return constants.iconUrl.Silver;
    }
    return constants.iconUrl.Gold;
};
var getPaintHeadline = function (currentLevel) {
    if (currentLevel === 'Member') {
        return constants.headline.Member;
    }
    if (currentLevel === 'Bronze') {
        return constants.headline.Bronze;
    }
    if (currentLevel === 'Silver') {
        return constants.headline.Silver;
    }
    return constants.headline.Gold;
};
var getPaintRewardsHeadline = function (currentLevel) {
    if (currentLevel === 'Member') {
        return undefined;
    }
    if (currentLevel === 'Bronze') {
        return 'Bronze Paint Rewards';
    }
    if (currentLevel === 'Silver') {
        return 'Silver Paint Rewards';
    }
    return 'Gold Paint Rewards';
};
var PaintSpend = function (_a) {
    var spendAmount = _a.spendAmount, currentLevel = _a.currentLevel, nextLevelName = _a.nextLevelName, nextDiscountPercentage = _a.nextDiscountPercentage, amountRequired = _a.amountRequired, progressPercentage = _a.progressPercentage;
    var amountDifference = Number(amountRequired);
    var amtDiffString = floorNumberWithCommas(amountDifference, 0);
    return (React.createElement("div", { className: "paint-spend-section sui-text-start" },
        React.createElement("div", { className: "sui-text-base" },
            "Paint Spend ",
            React.createElement("span", { className: "sui-font-bold" },
                "$",
                spendAmount),
            React.createElement(PaintInfoTooltip, null)),
        amountDifference <= 100 && currentLevel !== 'Gold' && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sui-w-48 sui-my-3" },
                React.createElement(ProgressBar, { value: progressPercentage, size: "large" })),
            React.createElement("p", { className: "rewards-paint-spend__caption-mobile" },
                "Spend",
                ' ',
                React.createElement("span", { className: "rewards-paint-spend__bold" },
                    "$",
                    amtDiffString),
                ' ',
                "to unlock ",
                nextLevelName,
                " Paint Rewards (Paint Rewards",
                ' ',
                nextDiscountPercentage || 0,
                "% off)")))));
};
var PaintRewardsMW = function (props) {
    var isLocked = props.isLocked, paintLevel = props.paintLevel, paintSpend = props.paintSpend, nextDiscountPercentage = props.nextDiscountPercentage, amountRequired = props.amountRequired, progressPercentage = props.progressPercentage, nextLevelName = props.nextLevelName;
    var paintIcon = getPaintIcon(paintLevel);
    var paintSubtitle = getPaintSubtitle(paintLevel, nextLevelName);
    var paintHeadline = getPaintHeadline(paintLevel);
    var data = __assign(__assign({}, props), { isLocked: isLocked, title: constants.title, headline: paintHeadline, subtitle: paintSubtitle, content: (React.createElement(PaintSpend, { spendAmount: paintSpend, currentLevel: paintLevel, nextDiscountPercentage: nextDiscountPercentage, amountRequired: amountRequired, progressPercentage: progressPercentage, nextLevelName: nextLevelName, isMobile: true })), iconUrl: paintIcon, footerButton: React.createElement(PaintRenderCTA, { isMobile: true }) });
    return React.createElement(BenefitCardMW, __assign({}, data));
};
var PaintRenderCTA = function (_a) {
    var isMobile = _a.isMobile;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var handleOpen = function () {
        setOpen(true);
        analyticsStash(rhAnalytics.viewPaintHistoryStash);
    };
    var handleClose = function () { return setOpen(false); };
    var isScreenLG = useBreakpoint('lg').greater;
    React.useEffect(function () {
        if (open)
            analyticsOverlay(rhAnalytics.viewPaintHistoryOverlay);
        newrelic.addPageAction(REWARDS_HUB_PAINT_VIEW_HISTORY_CLICK, {
            result: 'success',
            source: 'paint_benefit_card',
        });
    }, [open]);
    var ModalCTA = function () {
        return isMobile ? (React.createElement(Button, { variant: "text", onClick: handleOpen }, "View History")) : (React.createElement("button", { type: "button", className: "sui-cursor-pointer sui-underline sui-pt-4", onClick: handleOpen }, "View History"));
    };
    var ModalContent = function () {
        return isMobile ? (React.createElement(RewardsHistoryMW, { section: "body" })) : (React.createElement(RewardsHistoryDTW, { section: "body" }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalCTA, null),
        React.createElement(Modal, { open: open, onClose: handleClose, size: isScreenLG ? 'md' : 'lg' },
            React.createElement(ModalHeader, { onClose: handleClose }, "Paint Rewards History"),
            React.createElement(ModalBody, null,
                React.createElement(ModalContent, null)))));
};
var PaintRewardsFullWidthDTW = function (props) {
    var isLocked = props.isLocked, currentLevel = props.currentLevel, paintSpend = props.paintSpend;
    var data = __assign(__assign({}, props), { isLocked: isLocked, title: constants.title, headline: isLocked ? constants.headline : undefined, subtitle: constants.subtitle });
    return React.createElement(BenefitCardFullWidthDTW, __assign({}, data));
};
var PaintRewardsHalfWidthDTW = function (props) {
    var isLocked = props.isLocked, paintLevel = props.paintLevel, paintSpend = props.paintSpend, nextLevelName = props.nextLevelName, nextDiscountPercentage = props.nextDiscountPercentage, amountRequired = props.amountRequired, progressPercentage = props.progressPercentage;
    var paintIcon = getPaintIcon(paintLevel);
    var paintSubtitle = getPaintSubtitle(paintLevel, nextLevelName);
    var paintHeadline = getPaintHeadline(paintLevel);
    var paintSubheadline = getPaintRewardsHeadline(paintLevel);
    var data = __assign(__assign({}, props), { isLocked: isLocked, title: constants.title, headline: paintHeadline, paintHeadline: paintSubheadline, subtitle: paintSubtitle, content: (React.createElement(PaintSpend, { spendAmount: paintSpend, currentLevel: paintLevel, nextDiscountPercentage: nextDiscountPercentage, amountRequired: amountRequired, progressPercentage: progressPercentage, nextLevelName: nextLevelName })), iconUrl: paintIcon, headerButton: React.createElement(PaintRenderCTA, null) });
    return React.createElement(BenefitCardHalfWidthDTW, __assign({}, data));
};
export var PaintRewards = function (_a) {
    var isMobile = _a.isMobile, isLocked = _a.isLocked;
    var _b = React.useContext(RewardsHubContext), paintLevel = _b.paintLevel, paintSpend = _b.paintSpend, nextDiscountPercentage = _b.nextDiscountPercentage, amountRequired = _b.amountRequired, progressPercentage = _b.progressPercentage, nextLevelName = _b.nextLevelName;
    var data = {
        isMobile: isMobile,
        isLocked: isLocked,
        paintLevel: paintLevel,
        paintSpend: paintSpend,
        nextDiscountPercentage: nextDiscountPercentage,
        amountRequired: amountRequired,
        progressPercentage: progressPercentage,
        nextLevelName: nextLevelName,
    };
    return isMobile ? (React.createElement(PaintRewardsMW, __assign({}, data))) : (React.createElement(PaintRewardsHalfWidthDTW, __assign({}, data)));
};
